import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/multichain.png");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITFINES.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITGET.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BITMART.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/BYBIT.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/GATE.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/MEXC.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/OKX.svg");
;
import(/* webpackMode: "eager" */ "/app/public/partners/REF_FINANCE.svg");
;
import(/* webpackMode: "eager" */ "/app/public/research.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_round.png");
;
import(/* webpackMode: "eager" */ "/app/public/sweat_icon_square.png");
;
import(/* webpackMode: "eager" */ "/app/public/tokenomics_graph.svg");
;
import(/* webpackMode: "eager" */ "/app/public/utility.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/AppStoreButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/BurnHistory/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Button/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/ContextualLink/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/token/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/InstallSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Label/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/LivePrice/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PageSection/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/Scene/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/Slider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/TextReveal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/TokenMiniSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/VisibilityTracker/index.tsx");
